import { z } from 'zod'

import { imageColorInformationSchema } from './images'
import { idealoMinPriceByShopSchema } from '../idealo'
import { menuPageBuilderSchema } from './menuPageBuilder'
import { manufacturerGuaranteeProgramsSchema } from '../manufacturerGuarantees'

export const imageSchema = z.object({
  orig: z.string(),
  xs: z.string(),
  sm: z.string(),
  md: z.string(),
  color: imageColorInformationSchema.optional(),
})
export type Image = z.infer<typeof imageSchema>

export const brandSchema = z.object({
  id: z.number(),

  manufacturers: z.array(z.number()),

  title: z.string(),
  metaTitle: z.string(),
  metaDescription: z.string().optional(),
  metaKeywords: z.string().optional(),
  metaTitleSoundex: z.array(z.string()),
  titleAlternates: z.string().optional(),
  description: z.string().optional(),
  address: z.string().optional(),
  guaranteePrograms: manufacturerGuaranteeProgramsSchema.optional(),

  orderers: z.array(z.number()),

  logos: z.object({
    color: imageSchema.optional(),
    mono: imageSchema.optional(),
  }),
  logoVersion: z.number(),

  path: z.string(),

  discountRule: z.string().optional(),
  idealoMinPrice: idealoMinPriceByShopSchema.optional(),
  pageBuilder: menuPageBuilderSchema.optional(),

  created: z.date(),
  changed: z.date(),
  deleted: z.literal(true).optional(),
})
export type Brand = z.infer<typeof brandSchema>
